import { useState } from "react";
import { useTranslation } from "react-i18next";

import type { PersonLike } from "@lib/infrastructure";
import { PanelStackContext, useRoomBookingDraft } from "@lib/logic";
import type { MeetingRoom } from "@lib/store";
import { useRequiredContext } from "@lib/utils";
import { useScrollParentForChild } from "@hooks";
import { AddInviteesCardContent } from "src/components/organisms/createEvent/AddInviteesCardContent/AddInviteesCardContent";
import { ModalPageBottom } from "src/components/organisms/ModalPageBottom/ModalPageBottom";

import { HaNDetailsPage } from "../HaNDetailsPage";

// Picks the booking's invitees. They're only added to the booking on save, so going back leaves it as it was.
export const RoomInviteesPage = ({ room }: { room: MeetingRoom }) => {
  const { t } = useTranslation();
  const { pop } = useRequiredContext(PanelStackContext);
  const { draft, edit } = useRoomBookingDraft(room);
  const [invitees, setInvitees] = useState<PersonLike[]>(draft.invitees);
  const [selectedInvitee, setSelectedInvitee] = useState<number | undefined>(undefined);
  const [scrollRef, childWrapperRef] = useScrollParentForChild(selectedInvitee);

  const save = () => {
    edit({ invitees });
    pop();
  };

  return (
    <HaNDetailsPage
      title={t("screen:Invitees")}
      onBack={pop}
      footer={
        <ModalPageBottom
          className="p-0"
          buttonLabel={t("Save")}
          onClick={save}
        />
      }>
      <div
        ref={scrollRef}
        className="h-full overflow-y-auto px-5 py-6">
        <AddInviteesCardContent
          childWrapperRef={childWrapperRef}
          invitees={invitees}
          setInvitees={setInvitees}
          selectedInvitee={selectedInvitee}
          setSelectedInvitee={setSelectedInvitee}
        />
      </div>
    </HaNDetailsPage>
  );
};
